<template>
  <g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.0005 22.9983C13.2299 22.9983 14.2358 22.0534 14.2358 20.8984H9.76519C9.76519 22.0534 10.7711 22.9983 12.0005 22.9983ZM19.2647 16.699V10.9244C19.2647 7.70111 16.8841 5.00279 13.6765 4.28884V3.57489C13.6765 2.70345 12.9276 2 12 2C11.0724 2 10.3235 2.70345 10.3235 3.57489V4.28884C7.11588 5.00279 4.73529 7.70111 4.73529 10.9244V16.699L2.5 18.7988V19.8488H21.5V18.7988L19.2647 16.699Z"
    />
  </g>
</template>
